import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'

const isAccountDrawerOpen = atom<boolean>(false)

export function useSetAccountOpenDrawer(): (isOpen: boolean) => void {
  const setIsAccountDrawerOpen = useSetAtom(isAccountDrawerOpen)

  return useCallback(
    (isOpen: boolean) => {
      setIsAccountDrawerOpen(isOpen)
    },
    [setIsAccountDrawerOpen],
  )
}

export function useIsAccountDrawerOpen(): boolean {
  return useAtomValue(isAccountDrawerOpen)
}
